import createDynamicItemEndpoints from "./dynamicItem"

// The FAQ api is part of the 'DynamicItem' API, so its methods can be
// constructed by factory methods.

const { add, edit, get, remove } = createDynamicItemEndpoints('faq');

export { add, edit, get, remove };